import React from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';
import { ReactComponent as ConfirmCurrentStationIcon } from 'src/Images/icons/common/ConfirmCurrentStationIcon.svg';
import { ReactComponent as ConfirmExpectedtStationIcon } from 'src/Images/icons/common/ConfirmExpectedtStationIcon.svg';
import { ReactComponent as ConfirmTruckStationIcon } from 'src/Images/icons/common/ConfirmTruckStationIcon.svg';
import 'src/style/createVehicleTracking.css';
import { ReactComponent as ProfileIcon } from 'src/Images/icons/common/ProfileIcon.svg';
import { ReactComponent as ClockIcon } from 'src/Images/icons/common/clockIcon.svg';
import { ReactComponent as ConfirmationIcon } from 'src/Images/icons/common/ConfirmationIcon.svg';
import { useMediaQuery } from '@mui/system';

export default function ConfirmUpcomingWorkflowStageRequest({ onClose }) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { upcomingWorkflowStageRequest } = vehicleTrackingDataReducer;

  const currentStation = upcomingWorkflowStageRequest?.currentWorkflowStage;
  const expectedStation = upcomingWorkflowStageRequest?.expectedWorkflowStage;
  const chosenStation = upcomingWorkflowStageRequest?.requestedWorkflowStage;
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <div
      className={`theme-scrollable-container-${themeColor} div-flex-column  rg-10 right-drawer-component-medium`}
    >
      <div className="div-flex-row div-align-center div-space-between padding-top-10 padding-bottom-10 horizontal-padding-10 border-bottom">
        <div className=" div-flex-row cg-5 div-align-center text-lg text-semi-bold ">
          <ConfirmationIcon className=" icon-size-xxl" />
          Upcoming Station Confirmed
        </div>
        <button className="icon-btn-none" onClick={onClose} aria-label="Close">
          <Close className="icon-size-sm" />
        </button>
      </div>
      <div className="timeline-flow-wrapper">
        <svg
          viewBox={isMobile ? '70 20 380 550' : '0 20 500 550'}
          preserveAspectRatio="xMidYMid meet"
          className="responsive-timeline-svg"
          role="img"
        >
          {/* --- CURRENT STATION --- */}
          <foreignObject x="120" y="20" width="150" height="150">
            <ConfirmCurrentStationIcon />
          </foreignObject>
          <foreignObject x="226" y="42" width="200" height="80">
            <div className="div-flex-column div-align-center">
              <div className="label-title text-grey">Current Station</div>
              <div className="badge badge-green svg-badge">
                {currentStation}
              </div>
            </div>
          </foreignObject>
          <path
            d="M220 85
     C 160 140, 490 220, 410 220
     C 520 370, 200 390, 210 490"
            stroke="#C7C7C7"
            strokeWidth="2"
            strokeDasharray="6 6"
            fill="none"
          />

          {/* --- TRUCK ICON ON PATH --- */}
          <foreignObject x="340" y="170" width="120" height="120">
            <ConfirmTruckStationIcon width={120} />
          </foreignObject>

          {/* --- EXPECTED STATION --- */}
          <foreignObject x="55" y="240" width="150" height="150">
            <ConfirmExpectedtStationIcon />
          </foreignObject>
          <foreignObject x="162" y="262" width="200" height="80">
            <div className="div-flex-column div-align-center">
              <div className="label-title text-grey">Expected Station</div>
              <div className="badge badge-red svg-badge">{expectedStation}</div>
            </div>
          </foreignObject>
          {/* --- CHOSEN STATION --- */}
          <foreignObject x="124" y="480" width="150" height="150">
            <ConfirmCurrentStationIcon />
          </foreignObject>
          <foreignObject x="240" y="505" width="200" height="80">
            <div className="div-flex-column div-align-center">
              <div className="label-title text-grey">Chosen Station</div>
              <div className="badge badge-green svg-badge">{chosenStation}</div>
            </div>
          </foreignObject>
        </svg>
      </div>
      <div className=" div-flex-column vertical-padding-5 div-align-center">
        <div className="requested-info-card">
          <div className=" div-flex-row cg-10">
            <ProfileIcon className=" icon-size-lg" />
            <span className=" text-sm text-grey text-semi-bold">
              Requested By:{' '}
              <span>{upcomingWorkflowStageRequest?.requestedBy}</span>
            </span>
          </div>
          <hr className="requested-divider" />
          <div className=" div-flex-row cg-10">
            <ClockIcon className=" icon-size-lg" />
            <span className=" text-sm text-grey text-semi-bold">
              Requested On: <span>{upcomingWorkflowStageRequest?.created}</span>
            </span>
          </div>
        </div>
      </div>{' '}
    </div>
  );
}
